var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRoundArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0004 11H7.83041L12.7104 6.12001C13.1004 5.73001 13.1004 5.09001 12.7104 4.70001C12.6179 4.6073 12.508 4.53375 12.387 4.48357C12.2661 4.43339 12.1364 4.40756 12.0054 4.40756C11.8744 4.40756 11.7448 4.43339 11.6238 4.48357C11.5028 4.53375 11.3929 4.6073 11.3004 4.70001L4.71041 11.29C4.61771 11.3825 4.54416 11.4924 4.49398 11.6134C4.4438 11.7344 4.41797 11.864 4.41797 11.995C4.41797 12.126 4.4438 12.2557 4.49398 12.3766C4.54416 12.4976 4.61771 12.6075 4.71041 12.7L11.3004 19.29C11.393 19.3826 11.5029 19.456 11.6239 19.5061C11.7448 19.5562 11.8745 19.582 12.0054 19.582C12.1363 19.582 12.266 19.5562 12.387 19.5061C12.5079 19.456 12.6178 19.3826 12.7104 19.29C12.803 19.1974 12.8764 19.0875 12.9265 18.9665C12.9766 18.8456 13.0024 18.7159 13.0024 18.585C13.0024 18.4541 12.9766 18.3244 12.9265 18.2035C12.8764 18.0825 12.803 17.9726 12.7104 17.88L7.83041 13H19.0004C19.5504 13 20.0004 12.55 20.0004 12C20.0004 11.45 19.5504 11 19.0004 11Z",
    fill: "#6D6D6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRoundArrowBack);
export default __webpack_public_path__ + "static/media/ic_round-arrow-back.d464bd5b059a4c1ac214640c607fa130.svg";
export { ForwardRef as ReactComponent };